import _jsx from "@babel/runtime/helpers/jsx";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _FormattedMessage, _ModalTitle, _ModalText, _FormattedMessage2;

import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import { AdvertiserNoteText, CloseBtn, ModalText, ModalTitle } from './styles';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AdvertiserNote = function AdvertiserNote() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenModal = _useState2[0],
      setOpenModal = _useState2[1];

  var modalHandler = function modalHandler() {
    return setOpenModal(!isOpenModal);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AdvertiserNoteText, {
      onClick: modalHandler
    }, void 0, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      id: "header.advertiser_note"
    }))), /*#__PURE__*/_jsx(Modal, {
      isOpen: isOpenModal,
      onRequestClose: modalHandler,
      contentProps: {
        className: 'AdvertiserNoteModalContent',
        maxWith: '400px'
      }
    }, void 0, _ModalTitle || (_ModalTitle = /*#__PURE__*/_jsx(ModalTitle, {}, void 0, /*#__PURE__*/_jsx(FormattedMessage, {
      id: "header.advertiser_note"
    }))), _ModalText || (_ModalText = /*#__PURE__*/_jsx(ModalText, {}, void 0, /*#__PURE__*/_jsx(FormattedMessage, {
      id: "header.modal_text"
    }))), /*#__PURE__*/_jsx(CloseBtn, {
      type: "button",
      onClick: modalHandler
    }, void 0, _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/_jsx(FormattedMessage, {
      id: "hide"
    }))))]
  });
};

export default AdvertiserNote;